var simpleDirective = angular.module('simpleDirective', []);

/*----------------------------
  App functions
----------------------------*/
var isVisible = function( element) {
    // Update the dimensions of the element.

    var top = jQuery(element[0]).offset().top;
    var bottomFoldOffset = ( window.innerHeight + jQuery(window).scrollTop() );
    return(
                ( top < bottomFoldOffset )
    );
}

var setSrc = function(elem, imgAry, settings) {
  
  var $elem = $(elem);
  var width = settings.container.outerWidth();
  
  var i = 0;
  var temp = 0;
  var count = 0;
  var largest = 0;
  $.each(imgAry, function(key, value) {
    
    key = parseInt( key.split('w')[1] );
    
    if(key > width)
    {
      temp = key;
      count++;
      
      if( temp < i || i === 0 )
      {
        i = temp;
      }
    }
    if(key > largest)
    {
      largest = key;
    }
  });
  
  if(count === 0)
  {
    i = 'w'+largest;
  }
  else
  {
    i = 'w'+i;  
  }
  if( settings.background ){
    $elem.css({
      'background-image': 'url('+imgAry[i]+')',
    });
    setTimeout(function() {
     $elem.addClass("loaded");
    }, 10);
  }else{
    $elem.attr('src', imgAry[i]);
    setTimeout(function() {
     $elem.addClass("loaded");
    }, 10);
  }
  
}


simpleDirective.directive('collapse', function() {
  return {
      restrict: 'A',
      link: function(scope, elem, attrs){
      	angular.element(elem[0].querySelector('.collapse-header')).on('click', function() {
      		elem.toggleClass('collapsed');
      	})
      }
  };
});

simpleDirective.directive('getColor', function() {
  return {
      restrict: 'A',
      link: function(scope, elem, attrs){
        var slug = attrs.getColor;
        var color = scope.$root.badgeColors[slug];
        if(color.length > 0){
          elem.css({
            'background-color': color,
            'border-color' : color,
            'color' : '#fff'
          })
        }
        
      }
  };
});

simpleDirective.directive('unwrapImages', function($timeout) {
  return {
      restrict: 'A',
      link: function(scope, elem, attrs){
          $timeout(function(){
            var img = $(elem).find('img').not('.wp-smiley');
            $(img).each(function(name) {
              if ( $(this).parent('a').length > 0 ){
                $(this).unwrap();
              }
              if ( $(this).parent('p').length > 0 ){
                $(this).unwrap();
              }
            }); 
          });
      }
  };
});

simpleDirective.directive('fadeIn', function($window) {
  return {
      restrict: 'A',
      link: function(scope, elem, attrs){
        var w = angular.element($window);
        if( isVisible(elem) && !angular.element(elem).hasClass('in-view') ){
          angular.element(elem).addClass('in-view');
        }
        w.bind('scroll', function(){
          if( isVisible(elem) && !elem.hasClass('in-view') ){
            elem.addClass('in-view');
          }
        });
      }
  };
});
simpleDirective.directive('toggleSearch', function() {
  return {
      restrict: 'A',
      link: function(scope, elem, attrs){
        elem.bind('click', function() {
          if( $('.search-form-wrap').hasClass('active') ){
            $('.search-form-wrap').removeClass('active');
            $('.search-form-wrap input[type="search"]').blur();
          }else{
            $('.search-form-wrap').addClass('active');
            $('.search-form-wrap input[type="search"]').focus();
          }  
        });
      }
  };
});


simpleDirective.directive('hasChilds', function($window) {
  return {
      restrict: 'C',
      link: function(scope, elem, attrs){
        elem.bind('click', function(e) {
          if( $window.outerWidth < 1024 ){
            e.preventDefault();
            $(elem).parent().toggleClass('active');
          }
        });
      }
  };
});
simpleDirective.directive('secondaryNavWrap', function($window) {
  return {
      restrict: 'C',
      link: function(scope, elem, attrs){
        $('.main-nav a, .info-nav a').not('.has-childs').bind('click', function(e) {
          if( $window.outerWidth < 1024 ){
            $('.nav-wrap').removeClass('menu-active');
            $('.main-nav li').removeClass('active');
          }
        });
      }
  };
});
simpleDirective.directive('mobileSearchTrigger', function() {
  return {
      restrict: 'C',
      link: function(scope, elem, attrs){
        elem.bind('click', function() {
          if( $('.nav-wrap').hasClass('menu-active') ){
            $('.nav-wrap').removeClass('menu-active');
            setTimeout(function() {
              if( $('.search-form-wrap').hasClass('active') ){
                $('.search-form-wrap').removeClass('active');
                $('.search-form-wrap input[type="search"]').blur();
              }else{
                $('.search-form-wrap').addClass('active');
                $('.search-form-wrap input[type="search"]').focus();
              } 
            }, 470);
          }else{
            if( $('.search-form-wrap').hasClass('active') ){
              $('.search-form-wrap').removeClass('active');
              $('.search-form-wrap input[type="search"]').blur();
            }else{
              $('.search-form-wrap').addClass('active');
              $('.search-form-wrap input[type="search"]').focus();
            }
          }
        });
      }
  };
});
simpleDirective.directive('mobileMenuTrigger', function() {
  return {
      restrict: 'C',
      link: function(scope, elem, attrs){
        elem.bind('click', function() {
          if( $('.search-form-wrap').hasClass('active') ){
              $('.search-form-wrap').removeClass('active');
              $('.main-nav li').removeClass('active');
              $('.search-form-wrap input').blur();
              setTimeout(function() {
                if( $('.nav-wrap').hasClass('menu-active') ){
                  $('.nav-wrap').removeClass('menu-active');
                  $('.main-nav li').removeClass('active');
                }else{
                  $('.nav-wrap').addClass('menu-active');
                }
              }, 470);
          }else{
            if( $('.nav-wrap').hasClass('menu-active') ){
              $('.nav-wrap').removeClass('menu-active');
              $('.main-nav li').removeClass('active');
            }else{
              $('.nav-wrap').addClass('menu-active');
            }
          } 
        });
      }
  };
});
simpleDirective.directive('masonry', function($timeout) {
  return {
      restrict: 'A',
      link: function(scope, elem, attrs){
        $timeout(function(){
          var images = $(elem).find('img');
          imagesLoaded( images, function( instance ) {
             $(elem).masonry({
              itemSelector: '.masonry-item'
            });
          });
        });
      }
  };
});

simpleDirective.directive('resObjSrc', function($window) {
  return {
      restrict: 'A',
      link: function(scope, elem, attrs){
        var w = angular.element($window);
        var win = jQuery(window);
        var imageLoaded = false;

        var imageObj = JSON.parse(  attrs.resObjSrc  );

        var imgAry = {};

        $.each(imageObj, function(key, value) {
          if(key != 'thumbnail'){
            imgAry['w'+value.width] = value.url;
          }
         
        });

        function first(obj) {
          for (var a in obj) return a;
        }

        var settings = {
          background : false,
          container : jQuery(elem).parent(),
          lazyload : false,
        }

        if(attrs.background){
          settings['background'] = Boolean( attrs.background );
        }
        if(attrs.lazyload){
          settings['lazyload'] = Boolean( attrs.lazyload );
        }
        if(attrs.container){
          if(attrs.container == 'window'){
            settings['container'] = win;
          }else{
            settings['container'] = jQuery(elem).parents(attrs.container);
          }
        }

        function checkImage(){
          if( isVisible( elem ) ){
            setSrc(elem, imgAry, settings)
          }
        }
        
        if(!settings.lazyload){
          setSrc(elem, imgAry, settings);
          w.bind('resize', function () {
              setSrc(elem, imgAry, settings);
          });
        }else{
          checkImage();
          w.bind('scroll', function () {
        if(!imageLoaded){
          checkImage();
        }
          });
          w.bind('resize', function () {
              checkImage();
          });
        }
      }
  };
});

simpleDirective.directive('resSrc', function($window) {
  return {
      restrict: 'A',
      link: function(scope, elem, attrs){

        var w = angular.element($window);
        var win = jQuery(window);
        var imageLoaded = false;

        //image Array
        var imgAry = JSON.parse(  attrs.resSrc  );
        function first(obj) {
          for (var a in obj) return a;
        }

        var settings = {
          background : false,
          container : jQuery(elem).parent(),
          lazyload : false,
        }

        if(attrs.background){
          settings['background'] = Boolean( attrs.background );
        }
        if(attrs.lazyload){
          settings['lazyload'] = Boolean( attrs.lazyload );
        }
        if(attrs.container){
          if(attrs.container == 'window'){
            settings['container'] = win;
          }else{
            settings['container'] = jQuery(elem).parents(attrs.container);
          }
        }

        function checkImage(){
          if( isVisible( elem ) ){
            setSrc(elem, imgAry, settings)
          }
        }
        
        if(!settings.lazyload){
          setSrc(elem, imgAry, settings);
          w.bind('resize', function () {
              setSrc(elem, imgAry, settings);
          });
        }else{
          checkImage();
          w.bind('scroll', function () {
        if(!imageLoaded){
          checkImage();
        }
          });
          w.bind('resize', function () {
              checkImage();
          });
        }
        
      }
  };
});